exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.create-btn[data-v-d6d945d4] {\n  width: 120px !important;\n}\n", ""]);

// exports
